import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { SelectItem } from 'primeng/api';
import { CommonDoctorModel } from 'src/app/model/common/doctor';
import { CommonDoctorViewModel } from 'src/app/model/common/doctor.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

export interface CommonDoctorState {
  result: VonPageResponseModel<CommonDoctorViewModel>;
  data: CommonDoctorModel;
  residence: SelectItem<KhuyanaSelectItemModel>;
}

export const commonDoctorIS: CommonDoctorState = {
  result: {
    content: [],
    last: false,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0
  },
  data: {},
  residence: { value: {} }
};
